import React from 'react';

import { Col, Container, Row } from 'reactstrap';

import Main from 'components/Main';

const CheckoutLayout = ({ children }) => (
  <React.Fragment>
    <Main className="d-flex w-100">
      <Container fluid className="d-flex flex-column p-0" style={{ overflowX: 'hidden' }}>
        <Row className="h-100">
          <Col className="mx-auto d-table h-100">
            <div className="d-table-cell align-middle">{children}</div>
          </Col>
        </Row>
      </Container>
    </Main>
  </React.Fragment>
);

export default CheckoutLayout;
